export default "__VITE_ASSET__1408b0f5__"